import { STATUS } from "../lib/content";

export const StatusBadge = ({ status, className = "", testId }) => {
  const s = STATUS[status] || STATUS.in_development;
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-2 rounded-full border px-3 py-1 font-mono text-[11px] uppercase tracking-[0.14em] ${s.cls} ${className}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />
      {s.label}
    </span>
  );
};
